<input
  #autocompleteInput
  type="text"
  name="q"
  autocomplete="off"
  maxlength="200"
  value=""
  attr.placeholder="{{ inputPlaceholder }}"
  [ngModel]="inputText"
  (ngModelChange)="onTextInput($event)"
  (blur)="onInputBlur()"
  (focus)="onInputFocus()"
  attr.tabindex="{{ tabIndex }}" />
<span [ngClass]="{ hidden: hideProgress }" class="progress"></span>
<ul class="input-autocomplete" [ngClass]="{ hidden: hideAutoComplete }">
  <li
    *ngFor="let item of localAutocompleteData; let i = index"
    class="{{ item.cssClass }}"
    [ngClass]="{ header: item.isHeader, noclick: !item.isClickable }">
    <a
      (mousedown)="onAutocompleteItemClick(item)"
      [ngClass]="{ selected: item.selected }"
      (mouseover)="onAutocompleteItemHover(item)"
      [innerHTML]="item.name | autocompleteItemName: item.subName : inputText : item.highlightName"></a>
  </li>
</ul>
